"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSidebarFooterLayout = void 0;
const react_1 = __importDefault(require("react"));
function ContentSidebarFooterLayout({ children, sidebar, footer }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { "data-testid": "reschedule-main-content" }, children),
        sidebar,
        footer));
}
exports.ContentSidebarFooterLayout = ContentSidebarFooterLayout;
//# sourceMappingURL=ContentSidebarFooterLayout.js.map